module.exports = __webpack_public_path__ + "img/appAsset-brand--HubSpot.20b59dff.svg";